<template>
    <div  :class="baseerp+'div'" >
        <div class="flex a-i-c jcsb"style="margin:5px 14px" >
            <div>
                <span style="font-size: 14px;display: inline-block;padding-right: 5px">设备名</span>
                <el-input style=" width: 12%" v-model="vc_name" placeholder="搜索设备名" size="mini" clearable></el-input>
                <span style="font-size: 14px;display: inline-block;padding-right: 5px;padding-left: 5px">类型</span>
                <el-select v-model="i_ctype" size="mini"  style="width: 12%" @change="changeCtype" clearable>
                    <el-option v-for="item in i_ctypeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
                <span style="font-size: 14px;display: inline-block;padding-right: 5px;padding-left: 5px">设备类型</span>
                <el-select v-model="i_type" size="mini"  style="width: 12%" clearable>
                    <el-option v-for="item in i_typeList" :key="item.ywid" :label="item.name" :value="item.ywid"></el-option>
                </el-select>
                <span style="font-size: 14px;display: inline-block;padding-right: 5px;padding-left: 5px">状态</span>
                <el-select v-model="i_state" size="mini"  style="width: 12%" clearable>
                    <el-option v-for="item in i_stateList" :key="item.ywid" :label="item.name" :value="item.ywid"></el-option>
                </el-select>

                <!--            <span style="font-size: 14px;display: inline-block;padding-left: 5px;padding-right: 5px">设备编码</span><el-input style=" width:150px;" v-model="search" placeholder="搜索设备编码" size="mini">-->
                <!--            </el-input>-->
<!--                <span class=" middle" style="font-size: 14px;display: inline-block;padding-right: 5px;padding-left: 5px">下次检修日期</span>-->
<!--                <el-date-picker clearable size="mini" v-model="dt_s_nextcheck_date" formt="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date" style="width: 12%" placeholder="选择日期">-->
<!--                </el-date-picker>-->
<!--                <span class=" middle" style="font-size: 14px;display: inline-block;padding-right: 5px;padding-left: 5px">至</span>-->
<!--                <el-date-picker clearable size="mini" v-model="dt_e_nextcheck_date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date" style="width: 12%" placeholder="选择日期">-->
<!--                </el-date-picker>-->
<!--                <span class=" middle" style="font-size: 14px;display: inline-block;padding-right: 5px;padding-left: 5px">下次检验日期</span>-->
<!--                <el-date-picker clearable size="mini" v-model="dt_s_nextrepair_date" formt="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date" style="width: 12%" placeholder="选择日期">-->
<!--                </el-date-picker>-->
<!--                <span class=" middle" style="font-size: 14px;display: inline-block;padding-right: 5px;padding-left: 5px">至</span>-->
<!--                <el-date-picker clearable size="mini" v-model="dt_e_nextrepair_date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date" style="width: 12%" placeholder="选择日期">-->
<!--                </el-date-picker>-->
<!--                <span class=" middle" style="font-size: 14px;display: inline-block;padding-right: 5px;padding-left: 5px">报废日期</span>-->
<!--                <el-date-picker clearable size="mini" v-model="dt_s_bf_date" formt="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date" style="width: 12%" placeholder="选择日期">-->
<!--                </el-date-picker>-->
<!--                <span class=" middle" style="font-size: 14px;display: inline-block;padding-right: 5px;padding-left: 5px">至</span>-->
<!--                <el-date-picker clearable size="mini" v-model="dt_e_bf_date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date" style="width: 12%" placeholder="选择日期">-->
<!--                </el-date-picker>-->
<!--                <el-button  plain style="margin-left: 10px"   size="mini" @click="clearFun" >清空</el-button>-->
                <el-button  plain style="margin-left: 10px"   size="mini" @click="searchFun" >{{$t('button_search_for')}}</el-button>

            </div>

            <el-button  type="primary" :class="baseerp+'btn'" size="mini" @click="add">编辑</el-button>
        </div>
        <div style="padding-right: 9px;padding-left: 9px">
            <el-table
                    class="mrt10"
                    ref="table"
                    size="mini"
                    row-key="i_id"
                    :height="tableHeight"
                    border
                    :data="tableData"
                    :header-cell-style="{background:'#eef1f6',color:'#000'}"
                    :highlight-current-row="true"
                    @selection-change="selectionChange"
                    >
                <el-table-column  type="selection" width="50px" :reserve-selection="true" :selectable="selectable"></el-table-column>
<!--                <el-table-column align="center" label="图片" prop="vc_files"   show-overflow-tooltip>-->
<!--                    <template slot-scope="scope" >-->
<!--                        <div style="display: inline-block; overflow-x: auto" v-if="scope.row.vc_files&&scope.row.vc_files.otherfiles">-->
<!--                            <div v-for="(p,i) in scope.row.vc_files.otherfiles" style="display: inline-block; ">-->
<!--                                <el-image class="img" :src="file_root+'/'+p.vc_path" :preview-src-list="[file_root+'/'+p.vc_path]">-->
<!--                                </el-image>-->
<!--                            </div>-->
<!--                        </div>-->

<!--                    </template>-->
<!--                </el-table-column>-->
                <el-table-column align="center"  label="设备编码" prop="vc_no" show-overflow-tooltip></el-table-column>
                <el-table-column align="center" label="设备名" prop="vc_name"  show-overflow-tooltip></el-table-column>
                <el-table-column align="center" label="设备类型" prop="vc_typename" show-overflow-tooltip></el-table-column>
                <el-table-column align="center" label="品种" prop="vc_pzname"  show-overflow-tooltip></el-table-column>
                <el-table-column align="center" label="状态" prop="vc_statename"   show-overflow-tooltip></el-table-column>
                <el-table-column align="center" label="车间部门" prop="vc_gname"   show-overflow-tooltip></el-table-column>
                <el-table-column align="center" label="维修状态" prop="vc_mtstatename"   show-overflow-tooltip></el-table-column>
                <el-table-column align="center" label="类型" prop="vc_ctypename"   show-overflow-tooltip></el-table-column>
                <el-table-column align="center" label="规格型号" prop="vc_ggxh"   show-overflow-tooltip></el-table-column>
                <el-table-column align="center" label="采购金额" prop="f_pay"   show-overflow-tooltip></el-table-column>
                <el-table-column align="center" label="负责人" prop="vc_principal"   show-overflow-tooltip></el-table-column>
                <el-table-column align="center" label="供应客户" prop="vc_gykhname"   show-overflow-tooltip></el-table-column>
                <el-table-column align="center" label="购买时间" prop="dt_buytime"   show-overflow-tooltip></el-table-column>
                <el-table-column align="center" label="录入人" prop="vc_lruname"    show-overflow-tooltip></el-table-column>
                <el-table-column align="center" label="设备位号" prop="vc_tarno"    show-overflow-tooltip></el-table-column>
                <el-table-column align="center" label="工序位置" prop="vc_process"    show-overflow-tooltip></el-table-column>
                <el-table-column align="center" label="产品编号" prop="vc_product_no"    show-overflow-tooltip></el-table-column>
                <el-table-column align="center" :label="$t('form_notes')" prop="vc_note"    show-overflow-tooltip></el-table-column>
                <el-table-column align="center" label="合同厂家" prop="vc_ht_cj"    show-overflow-tooltip></el-table-column>
                <el-table-column align="center" label="制造厂家" prop="vc_zz_cj"    show-overflow-tooltip></el-table-column>
                <el-table-column align="center" label="安装厂家" prop="vc_az_cj"    show-overflow-tooltip></el-table-column>
                <el-table-column align="center" label="维保厂家" prop="vc_wb_cj"    show-overflow-tooltip></el-table-column>
                <el-table-column align="center" label="启用日期" prop="dt_start_date"    show-overflow-tooltip></el-table-column>
                <el-table-column align="center" label="设计寿命(年)" prop="f_designed_life"    show-overflow-tooltip></el-table-column>
                <el-table-column align="center" label="检修周期(月)" prop="f_repair_cycle"    show-overflow-tooltip></el-table-column>
                <el-table-column align="center" label="下次检修日期" prop="dt_nextrepair_date"    show-overflow-tooltip></el-table-column>
                <el-table-column align="center" label="检验周期(月)" prop="f_check_cycle"    show-overflow-tooltip></el-table-column>
                <el-table-column align="center" label="下次检验日期" prop="dt_nextcheck_date"    show-overflow-tooltip></el-table-column>
                <el-table-column align="center" label="报废日期" prop="dt_bf_date" show-overflow-tooltip></el-table-column>
                <el-table-column align="center" label="采购订单编号" prop="vc_purchaseno" show-overflow-tooltip></el-table-column>
                <!--            <el-table-column align="center" label="录入日期" prop="dt_createtime"   show-overflow-tooltip></el-table-column>-->
            </el-table>
            <el-pagination  style="margin-top: 10px;text-align: right"
                            background
                            @current-change="pageCurrentChange"
                            @size-change="sizeChange"
                            :page-sizes="[20,50,100]"
                            layout="total,sizes,prev, pager, next"
                            :current-page.sync="currentPage"
                            :total="total"
                            :page-size="pageSize">
            </el-pagination>

        </div>
         <el-dialog
                class="cldialog"
                style="display: flex;justify-content: center;align-items: center;"
                width="90%"
                top="30"
                height="90%"
                :title="detailTitle"
                :visible.sync="detailDialog"
                v-if="detailDialog"
                :close-on-click-modal="false" @close="detailClose">
            <detail-page :data="chooseList" @close="detailClose"></detail-page>
        </el-dialog>


    </div>
</template>

<script>
    import * as API from "./api"
    import DetailPage from "./DetailPage";
    import {baseerp,file_root} from "@/utils/baseUrl";
    export default {
        name: "index",
        components: {DetailPage},
        data() {
            return {
                tableHeight:0,
                baseerp:'',
                file_root:'',
                tableData:[],
                currentPage: 1,
                pageSize: 20,
                total:0,
                chooseList:[],
                detailDialog:false,
                detailTitle:'编辑',
                vc_name:'',
                dt_s_nextcheck_date:'',
                dt_e_nextcheck_date:'',
                dt_s_nextrepair_date:'',
                dt_e_nextrepair_date:'',
                dt_s_bf_date:'',
                dt_e_bf_date:'',
                i_ctype:'',
                i_type:'',
                i_state:'',
                i_typeList:[],
                i_ctypeList:[{id:1,name:'设备'},{id:2,name:'设备配件'}],
                i_mtstateList:[{id:1,name:'良好'},{id:2,name:'维修中'}],
                i_stateList:[
                    // {id:0,name:'未启用'},{id:1,name:'调试中'},{id:2,name:'运行中'},{id:-1,name:'已停机'},{id:-2,name:'已停用'}
                    ],
            }
        },
        watch: {

            '$root.workSize':{
                handler(n,o) {
                    this.onResize(n);
                },
                deep:true,
            },
        },
        activated(){
            this.onResize();
        },
        mounted() {
            this.baseerp=baseerp
            this.file_root=file_root
            this.getDeviceList()

            this.$nextTick(()=>{
                this.onResize();

            })
        },
        methods: {
            onResize (n){
                if (n==undefined) n=this.$root.workSize;

                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-100

            },
            selectable(row){
                if(this.chooseList.length){
                    if(row.i_type==this.chooseList[0].i_type&&row.i_ctype==this.chooseList[0].i_ctype){
                        return true
                    }else{
                        return false
                    }
                }else{
                    return true

                }

            },
            clearFun(){
                this.vc_name='';
                this.dt_s_nextcheck_date='';
                this.dt_e_nextcheck_date='';
                this.dt_s_nextrepair_date='';
                this.dt_e_nextrepair_date='';
                this.dt_s_bf_date='';
                this.dt_e_bf_date='';
                this.i_ctype='';
                this.i_type='';
                this.i_state='';
                this.currentPage=1
                this.getDeviceList()
            },
            selectionChange(val){
                this.chooseList=val
            },
            add(){
                if(this.chooseList.length==0){
                    this.$message.warning('请选择设备')
                    return
                }
                this.detailDialog=true
            },
            detailClose(type='back',data=[]){
                if (type=='back'){

                }else{
                    this.chooseList=[]
                    this.$refs.table.clearSelection();
                    this.getDeviceList()
                }
                this.detailDialog=false
            },
            searchFun(){
                this.currentPage=1;
                this.getDeviceList();
            },
            async getDeviceList(){
                let param={
                    vc_name:this.vc_name,
                    i_type:this.i_type,
                    i_ctype:this.i_ctype,
                    i_state:this.i_state,
                    dt_stime:this.dt_stime,
                    dt_etime:this.dt_etime,
                    currentPage:this.currentPage,
                    pageSize:this.pageSize,
                    dt_s_nextcheck_date:this.dt_s_nextcheck_date,
                    dt_e_nextcheck_date:this.dt_e_nextcheck_date,
                    dt_s_nextrepair_date:this.dt_s_nextrepair_date,
                    dt_e_nextrepair_date:this.dt_e_nextrepair_date,
                    dt_s_bf_date:this.dt_s_bf_date,
                    dt_e_bf_date:this.dt_e_bf_date,
                };
                let res=await API.getDeviceList(param);
                if ( res.code == 1 ){
                    this.total=res.total;
                    this.tableData=res.data;
                    this.tableData.map(t=>{
                        if(t.vc_files){
                            t.vc_files= JSON.parse(t.vc_files)
                        }
                    } )
                    // console.log(this.tableData)
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            changeCtype(){
                this.i_type='';
                this.i_state='';
                this.i_stateList=[];
                this.i_typeList=[];
                if(this.i_ctype==1){
                    this.getDeviceDict('type',7);
                    this.getDeviceDict('state',9);

                }else if(this.i_ctype==2){
                    this.getDeviceDict('type',8);
                    this.getDeviceDict('state',10);
                }
            },
            async getDeviceDict(type,val){
                let param={
                    type:val,
                };
                let res=await API.getDeviceDict(param);
                if ( res.code == 1 ){
                    if(type=='type'){
                        this.i_typeList=res.data
                    }else if(type=='state'){
                        this.i_stateList=res.data
                    }
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            pageCurrentChange(val){
                // console.log(val,"pageval");
                this.currentPage=val;
                //调用列表接口
                this.getDeviceList();
            },
            sizeChange(val){
                this.pageSize=val;
                this.currentPage=1;
                ///调用列表接口
                this.getDeviceList();
            },

        },
    }
</script>

<style lang="scss" scoped>
    .flex{
        display: flex;
        /*align-items: center;*/
    }
    .w100{
        width: 100%;
    }
    /deep/{
        .minw840 .el-dialog{
            min-width: 700px;
        }
        .el-table .cell{
            padding-right: 2px;
            padding-left: 2px;
        }
        .el-dialog__title,.el-dialog__headerbtn .el-dialog__close {
            color: white;
        }

    }

    .el-dialog__title,.el-dialog__headerbtn .el-dialog__close {
        color: white;
    }
    .dib{
        display: inline-block;
    }
    .ckys{
        width: 340px;
        display: inline-block;
        margin: 0 4px;
        border: 1px solid #DCDFE6;
    }
    .wi{
        width:inherit;
    }
    .w100-480{
        width: calc(100% - 350px);
    }
    .p-5-9{
        padding: 5px 9px;
    }
    .jcsb{
        justify-content: space-between;
    }
    .a-i-c{
    align-items: center;
    }
</style>